import { useEffect, useState } from 'react';

const useIsMobile = (breakpoint = 640) => {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') {
      return false;
    }

    return window.innerWidth < breakpoint;
  });

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const handlePageResized = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    handlePageResized();
    window.addEventListener('resize', handlePageResized);
    window.addEventListener('orientationchange', handlePageResized);
    window.addEventListener('load', handlePageResized);

    return () => {
      window.removeEventListener('resize', handlePageResized);
      window.removeEventListener(
        'orientationchange',
        handlePageResized
      );
      window.removeEventListener('load', handlePageResized);
    };
  }, [breakpoint]);

  return {
    isMobile,
  };
};

export default useIsMobile;
